export const calculatePageIndex = (skip: number, take: number): number => (skip + take) / take

export const calculateSkipIndex = (pageIndex: number, take: number): number =>
  pageIndex * take - take
